<script>
export default {
    name: "TableItemContainer",
};
</script>

<template>
    <slot />
</template>
